import CollapseHeader from "../collapse-header";

const PageHeader = ({ pageName, totalCount }) => {
  return (
    <div className="page-header mb-0">
      <div className="row align-items-center">
        <div className="col-4 d-flex gap-2  align-items-center ">
       
          <h4 className="page-title">
            {pageName}
            {totalCount ? (
              <span className="count-title">{totalCount}</span>
            ) : (
              ""
            )}
          </h4>
        </div>
        <div className="col text-end d-flex align-items-center justify-content-end">
          {/* <div>{children2}</div> */}
          <div className="head-icons">
            <CollapseHeader />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
